import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import AlertMessage from '../AlertMessage/AlertMessage';
import { errorMessages } from '../../helpers/messages';
import CustomModal from '../../shared/CustomModal';
import ForgotPassword from '../../components/ForgotPassword'
import { getImgSrc } from '../../helpers/GlobalFunctions';

class LoginComponent extends Component {
	render() {
		const { message, loginWithAzureAD, onSubmit, onInputChange, isLoading, onEnterPress, forgotPasswordModal, isShowForgotPwdModal, closeModal } = this.props;
		return (<div className="login-page">
			<div className="bg-white">
				<div className="container-fluid">
					<div className="container login-container" id="login">
						<div className="row">
							<div className="col-md-12">
								<div className="login_content">
									<div className="row">
										<div className="col-12">
											<div className="login-logo">
												<img src={getImgSrc('site_logo_caps.png')} alt="login logo" />
											</div>
										</div>
										<div className="col-12">
											<div className="d-grid mt-2">
												<button className="btn btn-azure" type="button" onClick={loginWithAzureAD}>LOGIN WITH CORPORATE ID</button>
											</div>
										</div>
										<div className="col-12">
											<div className="login-divider"><span>OR</span></div>
										</div>
										<div className="col-12">
											<form className="form-signin" onSubmit={onSubmit}>
												<div className="login-form-wrap d-flex flex-column align-items-between justify-content-between">
													{message ? <AlertMessage className="px-2 py-2" errorMessage={message} /> : null}
													<input
														type="text"
														id="inputEmail"
														className="form-control"
														value={this.props.username}
														onChange={(e) => onInputChange(e, 'username')}
														onKeyPress={onEnterPress}
														placeholder="Enter Username" />
													<input
														type="password"
														id="inputPassword"
														className="form-control"
														value={this.props.password}
														onChange={(e) => onInputChange(e, 'password')}
														onKeyPress={onEnterPress}
														placeholder="Enter Password" />
													
													<div className="row">
														<div className="col-7 align-content-center" data-testid="loginBtn">
															<div data-testid="forgot-password-text" className="forgot-password-text" onClick={forgotPasswordModal}>{errorMessages.login.forgotPassward}</div>
														</div>
														<div className="col-5">
															<div className="d-grid">
																<button className="btn btn-primary" id="loginBtn" type="button" onClick={onSubmit}>LOGIN</button>
															</div>
														</div>
													</div>
												</div>
												<input type="hidden" name="App Version" value={process.env.REACT_APP_VERSION} />
											</form>
										</div>

									</div>
								</div>
							</div>
							<div className="col-md-12">

							</div>

						</div>
					</div>
					{/* Modal for password reset */}
					<CustomModal
						id="forgot-password"
						data-testid="forgot-password"
						dialogClassName="forgot-password"
						show={isShowForgotPwdModal}
						isComponent={true}
						title="Forgot Password"
						closeAction={() => forgotPasswordModal()}>
						<ForgotPassword closeAction={closeModal} />
					</CustomModal>
				</div>
				{isLoading ? <div className="loading-overlay"><span>{errorMessages.login.logIn}</span></div> : null}
			</div>
		</div>);
	}
}

LoginComponent.propTypes = {
	onSubmit: PropTypes.func,
	message: PropTypes.any
};

const mapStateToProps = (state) => (
	{
		state
	}
)

const mapDispatchToProps = (dispatch) => ({

})


export default connect(mapStateToProps, mapDispatchToProps)(LoginComponent);
